/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetYoutubePlaylistsQueryResponse, SocialExportGetYoutubePlaylistsPathParams, SocialExportGetYoutubePlaylists400, SocialExportGetYoutubePlaylists401, SocialExportGetYoutubePlaylists403, SocialExportGetYoutubePlaylists404 } from "../models/SocialExportGetYoutubePlaylists";

export function getSocialExportGetYoutubePlaylistsUrl(connectionId: SocialExportGetYoutubePlaylistsPathParams["connectionId"]) {
  const res = { method: 'GET', url: `/social-export/v1/platforms/youtube/${connectionId}/playlists` as const }
  return res
}

/**
 * @description Returns all playlists owned by the authenticated YouTube user for the connection (may use cache).
 * @summary Get YouTube playlists for a connection
 * {@link /social-export/v1/platforms/youtube/:connectionId/playlists}
 */
export async function socialExportGetYoutubePlaylists(connectionId: SocialExportGetYoutubePlaylistsPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetYoutubePlaylistsQueryResponse, ResponseErrorConfig<SocialExportGetYoutubePlaylists400 | SocialExportGetYoutubePlaylists401 | SocialExportGetYoutubePlaylists403 | SocialExportGetYoutubePlaylists404>, unknown>({ method : "GET", url : getSocialExportGetYoutubePlaylistsUrl(connectionId).url.toString(), ... requestConfig })
  return res.data
}